export default class Header {
  constructor () {
    this.$menu = $('.mHeader-menu');
    this.$head = $('.mHeader-head');
    this.$body = $('.mHeader-body');
    this.$mainItemWithChildren = $('.mHeader-main-item.has-children');
    this.$menu.on('click', this.toggleMenu.bind(this));
    this.open = false;
    this.$mainItemWithChildren.find('.mHeader-main-link').on('click', this.onMainClick.bind(this));
    console.log(this.$mainItemWithChildren.find('.mHeader-main-link'));
  }
  onMainClick (event) {
    event.preventDefault();
    $(event.currentTarget).parent().toggleClass('is-open');
  }
  mainOnMouseLeave (event) {
    event.preventDefault();
    $(event.currentTarget).removeClass('is-open');
  }
  toggleMenu () {
    if (this.open) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
    this.open = !this.open;
  }
  openMenu () {
    this.$menu.addClass('is-open');
    this.$head.addClass('is-open');
    this.$body.addClass('is-open');
    $(document.body).addClass('is-fixed');
    $.Velocity(this.$body, {
      opacity: 1,
    }, {
      duration: 100,
      easing: 'easeInOut',
    }).then(() => {
    });
  }
  closeMenu () {
    this.$menu.removeClass('is-open');
    this.$head.removeClass('is-open');
    this.$body.removeClass('is-open');
    $(document.body).removeClass('is-fixed');
    $.Velocity(this.$body, {
      opacity: 0,
    }, {
      duration: 100,
      easing: 'easeInOut',
    }).then(() => {
      this.$body.css({
        opacity: ''
      });
    });
  }
}


// WEBPACK FOOTER //
// ./scripts/components/modules/Header.js